// ============================================================================
// SEARCH HASH PRODUCTS - Cookie-Based Visibility
// ============================================================================
// Shows/hides hash-only products in search results based on:
// 1. User's cookie (approved products)
// 2. showInSearch flag in HASH_ONLY_CONFIG
// ============================================================================

(function() {
  'use strict';

  // Wait for config to be available
  const cookieName = 'ghf_hash_products';
  
  function getConfig() {
    return window.HASH_ONLY_CONFIG || {};
  }

  // Get approved hash products from cookie
  function getApprovedHashProducts() {
    const value = "; " + document.cookie;
    const parts = value.split("; " + cookieName + "=");
    if (parts.length === 2) {
      const cookieValue = parts.pop().split(";").shift();
      return cookieValue ? cookieValue.split(',').filter(id => id) : [];
    }
    return [];
  }

  // Show/hide hash products based on cookie and config
  function showApprovedHashProducts() {
    const config = getConfig();
    const approvedProducts = getApprovedHashProducts();
    const hashProducts = document.querySelectorAll('.hash-product');
    
    if (hashProducts.length === 0) return; // No hash products found

    hashProducts.forEach(productCard => {
      const productId = productCard.getAttribute('data-product-id');
      const productConfig = config[productId] || {};
      
      let shouldShow = false;

      // Check showInSearch flag
      if (productConfig.showInSearch === true) {
        // Explicit YES - always show
        shouldShow = true;
      } else if (productConfig.showInSearch === false) {
        // Explicit NO - never show (even with cookie)
        shouldShow = false;
      } else {
        // Default behavior - show only if user has cookie
        shouldShow = approvedProducts.includes(productId);
      }

      // Show or keep hidden
      if (shouldShow) {
        productCard.classList.remove('hidden');
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showApprovedHashProducts);
  } else {
    showApprovedHashProducts();
  }

  // Watch for predictive search results (AJAX loaded)
  const observer = new MutationObserver(function(mutations) {
    // Use setTimeout to ensure DOM is fully updated
    setTimeout(function() {
      const hashProducts = document.querySelectorAll('.hash-product.hidden');
      if (hashProducts.length > 0) {
        showApprovedHashProducts();
      }
    }, 50);
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
